import apiClient from "config/apiClient";
import Notify from "config/notify";

interface StoreSelectRequest {
  store_cd_or_name?: string;
  pref_cd?: string;
  status_flag?: number;
  store_cd?: string;
  managed_logistics_cd?: string;
  limit: number;
  offset: number;
}

/**
 * Fetches a list of stores based on the provided search parameters.
 * @param {StoreSelectRequest} params - The search parameters for fetching stores.
 */
const fetchStores = async (params: StoreSelectRequest): Promise<any> => {
  const searchParams: StoreSelectRequest = {
    offset: 0,
    limit: 10,
  };
  searchParams.offset = params.offset;
  searchParams.limit = params.limit;
  if ((params.pref_cd as string).trim() !== "")
    searchParams.pref_cd = (params.pref_cd as string).trim();
  if ((params.store_cd_or_name as string).trim() !== "")
    searchParams.store_cd_or_name = (params.store_cd_or_name as string).trim();
  if (params.status_flag !== undefined) searchParams.status_flag = params.status_flag;
  if ((params.store_cd as string).trim() !== "")
    searchParams.store_cd = (params.store_cd as string).trim();
  if ((params.managed_logistics_cd as string).trim() !== "")
    searchParams.managed_logistics_cd = (params.managed_logistics_cd as string).trim();
  const response = await apiClient.post("/mst/store/select", searchParams);
  return response.data;
};

/**
 * Updates the store details.
 * @param {Store} store - The store object containing updated details.
 * @returns {Promise<any>} The data from the API response.
 * @throws Will throw an error if the request fails.
 */
interface Store {
  store_cd: string;
  mst_store_status_flag: number;
  mst_store_store_name: string;
}

/**
 * Updates the store details.
 * @param {Store} store - The store object containing updated details.
 * @returns {Promise<any>} The data from the API response.
 * @throws Will throw an error if the request fails.
 */
const updateStore = async (store: Store): Promise<any> => {
  const response = await apiClient.post(`/mst/store/update`, {
    store_cd: store.store_cd,
    mst_store_status_flag: store.mst_store_status_flag,
    mst_store_store_name: store.mst_store_store_name,
  });
  if (response.status === 200) {
    Notify.setNotification({
      show: true,
      title: "更新が完了しました",
      confirmLabel: "OK",
      actionsPosition: "center",
    });
  }
  return response;
};

export { fetchStores, updateStore };
